import { tw } from "@careinfo/tailwind";
import Button from "../../../Reusable/Button";
import Card from "../../../Reusable/Card";
import { useForm } from "react-hook-form";
import Form from "../CashForm";
import { yupResolver } from "@hookform/resolvers/yup";
import { validatePaymentReceipt } from "../../../../validation/CashPaymentReceipt";
import { useState } from "react";
import PopupModal from "../../../Reusable/Modal";
import CreatePartyPopup from "../../CreatePartyPopup";
import { useNavigate } from "react-router-dom";
import CreateAccountPopup from "../CreateAccountPopup";
import { getKey } from "../../../../helpers/sessionKey";

const EditCashReceipt = (props: any) => {
  const navigate = useNavigate();
  const [openAccountPopup, setOpenAccountPopup] = useState(false);
  const [openpartypopup, setpartypopup] = useState(false);
  const [openCancelBiLLPopup, setOpenCancelBillPopup] = useState(false);
  const {
    handleEdit,
    isLoading,
    data,
    handleCreateCashAccount,
    isPostLoding,
    openPrintPopup,
    setOpenPrintPopup,
    handleRevert,
    isRevertLoading,
    isPrintLoading,
    handlePrint,
    handleCancel,
  } = props;
  const {
    control,
    register,
    formState: { errors },
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    watch,
    setError,
  } = useForm<any>({
    resolver: yupResolver(validatePaymentReceipt),
    defaultValues: async () => {
      return {
        ...data,
      };
    },
  });

  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/cash-receipt");
  };

  const isSuperUser = getKey("is_superuser");
  const adminOnly = data?.is_draft;

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleEdit(data, false, setError))}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            setValue={setValue}
            getValues={getValues}
            clearErrors={clearErrors}
            setError={setError}
            watch={watch}
            isDraft={data?.is_draft}
            setOpenAccountPopup={setOpenAccountPopup}
            setpartypopup={setpartypopup}
          />
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            {/* <div className={tw`w-24 `}>
              <Button
                type="button"
                // disabled={!adminOnly}
                label="Cancel"
                isLoading={isLoading}
                onClick={() => setOpenCancelBillPopup(true)}
              />
            </div> */}
            {data?.is_draft ? (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  disabled={!adminOnly}
                  label="Save to Draft"
                  isLoading={isLoading}
                  onClick={handleSubmit((data) =>
                    handleEdit(data, true, setError)
                  )}
                />
              </div>
            ) : (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  // disabled={!adminOnly}
                  label="Revert"
                  isLoading={isRevertLoading}
                  onClick={() => handleRevert(setError)}
                />
              </div>
            )}
            <div className={tw`w-24`}>
              <Button
                label="Submit"
                disabled={!data?.is_draft}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Cash Account"
      >
        <CreateAccountPopup
          handleCreateAccount={handleCreateCashAccount}
          isLoading={isPostLoding}
          setOpenAccountPopup={setOpenAccountPopup}
        />
      </PopupModal>
      <PopupModal
        isOpen={openCancelBiLLPopup}
        setIsOpen={setOpenCancelBillPopup}
        title="Cancel Bill"
      >
        <div className={tw`p-4 mt-10`}>
          <p className={tw`text-gray-600 mb-6`}>
            Are you sure you want to cancel this bill? This action cannot be
            undone.
          </p>

          <div className={tw`flex justify-center gap-3`}>
            <button
              onClick={() => setOpenCancelBillPopup(false)}
              className={tw`px-6 py-2 rounded-md focus:outline-none bg-gray-200 text-gray-800 hover:bg-gray-300 transition`}
            >
              No
            </button>

            <button
              onClick={() => {
                handleCancel();
                setOpenCancelBillPopup(false);
              }}
              className={tw`px-6 py-2 rounded-md  focus:outline-none bg-red-600 text-white hover:bg-red-700 transition`}
            >
              Yes
            </button>
          </div>
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openpartypopup}
        setIsOpen={setpartypopup}
        title="Party Account"
      >
        <CreatePartyPopup setpartypopup={setpartypopup} setParty={setValue} />
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </>
  );
};
export default EditCashReceipt;
